import { FilterPage, FilterSort, Index, Status, Tag, WeightedChar } from "@core/data";
export interface TastingCustomWeightedCharIndexStateModel {
    // org context
    orgKey: string;

    // page data
    status: Status;
    data: WeightedChar[];
    total: number;

    // data options
    displayColumns: string[];
    sortOptions: {id: string, label: string}[];
    pageSizeOptions: number[];
    tagOptions: Tag[];
    indexOptions: Index[];

    // filter options
    page: FilterPage;
    sort: FilterSort;
    query: TastingCustomWeightedCharQuery;

    // selection
    selectedKeys: string[];
    selectedData: WeightedChar[];
}

export interface TastingCustomWeightedCharQuery {
    search: string;
    indexKeys: string[];
    tagKeys: string[];
}

export const TASTING_CUSTOM_WEIGHTED_CHAR_SORT_OPTIONS: {id: string, label: string}[] = [
    { id: 'label', label: 'Label' },
    { id: 'updatedAt', label: 'Updated Date' },
    { id: 'createdAt', label: 'Created Date' },
];

export const TASTING_CUSTOM_WEIGHTED_CHAR_DISPLAY_COLUMNS = [
    'checkbox',
    'label',
    'weight',
    'tagsCount',
    'indexCount',
    'actions',
    'timestamps'
];

export const DEFAULTS: TastingCustomWeightedCharIndexStateModel = {
    orgKey: null,
    status: Status.UNINITIALIZED,
    data: [],
    total: 0,
    displayColumns: TASTING_CUSTOM_WEIGHTED_CHAR_DISPLAY_COLUMNS,
    sortOptions: TASTING_CUSTOM_WEIGHTED_CHAR_SORT_OPTIONS,
    pageSizeOptions: [5, 10, 20, 50, 100, 500],
    tagOptions: [],
    indexOptions: [],
    page: {
        index: 0,
        size: 20,
    },
    sort: {
        column: 'updatedAt',
        order: 'desc',
    },
    query: {
        search: null,
        indexKeys: [],
        tagKeys: [],
    },
    selectedKeys: [],
    selectedData: [],
}